import React from "react";
import CommonModal from "../CommonModal"; 
import Button from "../../Elements/Button"; 

const InternalExtendBeyondModal = ({
    openModal,
    closeModal,
    tool,     
    setTool,  
    revertTo,
    setShowToast 
}) => {

    const handleYes = () => {
        setTool(prevTool => ({
            ...prevTool,
            geometry: {
                ...prevTool.geometry,
                keep_within_page: false, // Update the setting to allow extension
            },
        }));

        if (setShowToast) {
            setShowToast({
                showToast: true,
                toastType: 'success',
                toastMessage: "Element can now extend beyond page borders.",
            });
        }
        closeModal(false); 
    };

    const handleNo = () => {
        setTool(prevTool => ({ ...prevTool, geometry: { ...prevTool.geometry, ...revertTo } }));

        if (setShowToast) {
            setShowToast({
                showToast: true,
                toastType: 'info',
                toastMessage: "Element dimensions reverted to fit page.",
            });
        }
                
        closeModal(false); 
    };

    return (
        <CommonModal
            title={"Extend Beyond Page"}
            modalStatus={openModal}
            changeActiveStatus={closeModal}
            classList="header-profile-modal-wrapper alert-modal"
            showFooter={false}
            centered
        >
            <div className="clone-modal">
                <div className="mb-2">
                    This element is extending beyond the document borders. <br />
                    Click "Yes" to allow it to extend, or "No" to revert its size/position to fit the page.
                  
                </div>
                <div className="kdf-btn mt-3">
                    <Button
                        text={'No'}
                        classList={"alert"}
                        addonClass={'me-1 px-2'}
                        onClick={handleNo}
                    />
                    <Button
                        text={'Yes'}
                        classList={"success"}
                        type="submit"
                        addonClass={'px-2 common-modal-yes-button'}
                        onClick={handleYes}
                    />
                </div>
            </div>
        </CommonModal>
    );
};

export default InternalExtendBeyondModal;